import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui/button';

interface CommissionPayerSelectorProps {
  title: string;
  hint: string;
  merchantPays: boolean;
  onChange: (merchantPays: boolean) => void;
}

export function CommissionPayerSelector({
  title,
  hint,
  merchantPays,
  onChange,
}: CommissionPayerSelectorProps) {
  const { t } = useTranslation('cabinet');

  return (
    <section className="surface-card space-y-2">
      <h2 className="section-title">{title}</h2>
      <p className="text-sm text-muted-foreground">{hint}</p>

      <div className="space-y-1.5 pt-1">
        <p className="text-sm font-medium text-foreground">
          {t('projects.form.commissionPayerLabel')}
        </p>
        <div
          className="inline-flex w-full max-w-sm rounded-lg border border-border bg-[var(--base-muted,#F5F5F5)] p-1"
          role="group"
          aria-label={title}
        >
          <Button
            type="button"
            size="sm"
            variant={!merchantPays ? 'default' : 'secondary'}
            className="flex-1"
            aria-pressed={!merchantPays}
            onClick={() => onChange(false)}
          >
            {t('projects.form.commissionPayerCustomer')}
          </Button>
          <Button
            type="button"
            size="sm"
            variant={merchantPays ? 'default' : 'secondary'}
            className="flex-1"
            aria-pressed={merchantPays}
            onClick={() => onChange(true)}
          >
            {t('projects.form.commissionPayerMerchant')}
          </Button>
        </div>
      </div>
    </section>
  );
}
